// Product Estimated Delivery JavaScript

const months = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

document.addEventListener('DOMContentLoaded', function() {
  const deliveryBlocks = document.querySelectorAll('[data-delivery-block]');
  
  deliveryBlocks.forEach(function(block) {
      const deliveryText = block.querySelector('[data-delivery-text]');
      if (!deliveryText) return;
      
      // Get data attributes from the block
      const minDays = parseInt(block.dataset.minDays) || 5;
      const maxDays = parseInt(block.dataset.maxDays) || 10;
      const cutoffTime = block.dataset.cutoffTime || '08:00';
      const disableMaxDays = block.dataset.disableMaxDays === 'true';
      const disclaimerText = block.dataset.disclaimerText || '';
      

      
      // Calculate delivery dates
      const deliveryInfo = calculateDeliveryDates(minDays, maxDays, cutoffTime, disableMaxDays);
      
      // Update the text
      deliveryText.textContent = deliveryInfo.mainText;
      
      // Update disclaimer if exists
      const disclaimer = block.querySelector('.product-estimated-delivery__disclaimer');
      if (disclaimer && disclaimerText) {
          disclaimer.textContent = disclaimerText;
      }
  });
});

function calculateDeliveryDates(minDays, maxDays, cutoffTime, disableMaxDays) {
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  
  // Parse cutoff time
  const [cutoffHour, cutoffMinute] = cutoffTime.split(':').map(Number);
  const currentTimeMinutes = currentHour * 60 + currentMinute;
  const cutoffTimeMinutes = cutoffHour * 60 + cutoffMinute;
  
  
  // Add extra day if current time is after cutoff
  const extraDay = currentTimeMinutes > cutoffTimeMinutes ? 1 : 0;
  
  // Calculate minimum delivery date (calendar days)
  const minDate = addCalendarDays(now, minDays + extraDay);
  
  // Calculate maximum delivery date (calendar days)
  const maxDate = addCalendarDays(now, maxDays + extraDay);
  
  // Format dates
  const minFormatted = formatDate(minDate);
  const maxFormatted = formatDate(maxDate);
  
  
  // Create text
  let mainText;
  if (disableMaxDays) {
      mainText = `Chegará entre ${minFormatted}`;
  } else {
      // Check if both dates are in the same month
      if (minDate.getMonth() === maxDate.getMonth() && minDate.getFullYear() === maxDate.getFullYear()) {
          // Same month - show month only once
          const minDay = minDate.getDate();
          const maxDay = maxDate.getDate();
          const month = months[minDate.getMonth()];
          mainText = `Chegará entre ${minDay} e ${maxDay} de ${month}`;
      } else {
          // Different months - show both full dates
          mainText = `Chegará entre ${minFormatted} e ${maxFormatted}`;
      }
  }
  
  return {
      mainText: mainText,
      minDate: minDate,
      maxDate: maxDate
  };
}

function addCalendarDays(date, calendarDays) {
  const result = new Date(date);
  
  // Start from tomorrow (first day)
  result.setDate(result.getDate() + 1);
  
  
  // Add calendar days (we already have the first day, so add calendarDays - 1 more)
  for (let i = 0; i < calendarDays - 1; i++) {
      result.setDate(result.getDate() + 1);
  }
  
  // If the final date falls on Sunday, move to Monday
  if (result.getDay() === 0) { // Sunday
      result.setDate(result.getDate() + 1); // Move to Monday
  }
  
  return result;
}

function getDayName(day) {
  const days = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
  return days[day];
}

function formatDate(date) {
  const day = date.getDate();
  const month = months[date.getMonth()];
  
  return `${day} de ${month}`;
} 